<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="text-center fw-bold w-100">{{ "helpdesk.attachment" | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body overflow-x-hidden p-3">
        <form class="col-12" [formGroup]="attachmentForm">
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.nameAE' | translate"
                        formControlName="nameAE"
                        controlName="nameAE"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('nameAE')"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.nameEN' | translate"
                        formControlName="nameEN"
                        controlName="nameEN"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('nameEN')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <adaa-form-input-file
                        attachUrl="helpdesk/attachmentFile"
                        downloadUrl="helpdesk/attachmentFile"
                        label="common.form.label.file"
                        [onDeleteRemoveFile]="false"
                        [isDisabled]="pageMode() === PageMode.view"
                        [allowedFileSize]="26214400"
                        [allowedFiles]="allowedFiles"
                        [allowedFilesMessage]="message"
                        [file]="getFile()"
                        [required]="true"
                        (inputChanges)="onFilechange($event)"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <adaa-form-input-date
                        controlName="attachDate"
                        formControlName="attachDate"
                        [label]="'common.form.label.attachment_date' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('attachDate')"
                    />
                </div>
            </div>
        </form>
    </div>
    <div class="modal=footer d-flex justify-content-center mt-3">
        <adaa-form-action-buttons
            [showSaveButton]="pageMode() !== PageMode.view"
            [cancelButtonTitle]="pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)"
            (cancelClicked)="modal.close()"
            (saveClicked)="submit()"
        />
    </div>
</ng-template>
